import { notifications } from '@mantine/notifications'
import type { QueryClient } from '@tanstack/react-query'
import { useQueryClient } from '@tanstack/react-query'

import {
  useEmployerUsersServiceEmployerUsersControllerChangeRole,
  useEmployerUsersServiceEmployerUsersControllerDeleteEmployee,
  useEmployerUsersServiceEmployerUsersControllerGetAllEmployeesKey,
} from '@/__generated__/queries'
import type { role } from '@/__generated__/requests'

function handleSuccess(queryClient: QueryClient) {
  queryClient.invalidateQueries({
    queryKey: [
      useEmployerUsersServiceEmployerUsersControllerGetAllEmployeesKey,
    ],
  })
}

export function useUserItemDelete(userId: string) {
  const queryClient = useQueryClient()

  const deleteMutation =
    useEmployerUsersServiceEmployerUsersControllerDeleteEmployee({
      onSuccess: () => {
        notifications.show({
          color: 'green',
          message: 'User has been successfully deleted',
          title: 'User deleted',
        })
        handleSuccess(queryClient)
      },
    })

  return {
    deleteUser: () => deleteMutation.mutate({ userId: +userId }),
  }
}

export function useUpdateRole(userId: string, newRole: role) {
  const queryClient = useQueryClient()

  const updateMutation =
    useEmployerUsersServiceEmployerUsersControllerChangeRole({
      onSuccess: () => {
        notifications.show({
          color: 'green',
          message: 'Role has been successfully updated',
          title: 'Role updated',
        })
        handleSuccess(queryClient)
      },
    })

  return {
    updateRole: () =>
      updateMutation.mutate({
        requestBody: { role: newRole },
        userId: +userId,
      }),
  }
}
